import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

export const useI18nLanguage = () => {
  const { i18n } = useTranslation();

  const selectedLanguageForMoment = useMemo(() => {
    const i18nLng = i18n?.language.toLowerCase();
    const currentLng =
      i18n?.language?.split("-")?.[0]?.toLocaleLowerCase() ?? "en";
    // Get all available moment locales
    const availableLocales = moment.locales();

    // Find the first occurrence of either i18nLng or currentLng in available locales
    const matchedLocale = availableLocales.find(
      (locale) => locale === i18nLng || locale === currentLng
    );

    // Use the matched locale if found, otherwise default to currentLng
    const localeToUse = matchedLocale || currentLng;

    return localeToUse;
  }, [i18n.language]);
  return { selectedLanguageForMoment };
};
